import http from '@/http'

export default {
  namespaced: true,
  actions: {
    async listCustomerGender() {
      const response = await http.get(`enumeration/customer-gender`)

      return response
    },
    async listOrderCustomerType() {
      const response = await http.get(`enumeration/order-customer-type`)

      return response
    },
    async listOrderStatus() {
      const response = await http.get(`enumeration/order-status`)

      return response
    },
    async listOrderType() {
      const response = await http.get(`enumeration/order-type`)

      return response
    },
    async listOrderExportFormat() {
      const response = await http.get(`enumeration/order-export-format`)

      return response
    },
    async listAdvancePeriods() {
      const response = await http.get(`enumeration/order-advance-period`)

      return response
    },
    async listAdvanceTypes() {
      const response = await http.get(`enumeration/order-advance-type`)

      return response
    },
    async listTerminationPeriodTypes() {
      const response = await http.get(`enumeration/order-termination-period-type`)

      return response
    },
    async listRenewalPeriodTypes() {
      const response = await http.get(`enumeration/order-renewal-period-type`)

      return response
    },
    async listRenewalPeriodUnit() {
      const response = await http.get(`enumeration/order-renewal-period-unit`)

      return response
    },
    async listSupplierServiceTypes() {
      const response = await http.get(`enumeration/supplier-service-type`)

      return response
    },
    async listSupplierProductType() {
      const response = await http.get(`enumeration/supplier-product-type`)

      return response
    },
    async listSupplierProductStatus() {
      const response = await http.get(`enumeration/supplier-product-status`)

      return response
    },
    async listProductContractType() {
      const response = await http.get(`enumeration/product-contract-type`)

      return response
    },
    async listProductContractPeriodUnit() {
      const response = await http.get(`enumeration/product-contract-period-unit`)

      return response
    },
    async listContractType() {
      const response = await http.get(`enumeration/contract-type`)

      return response
    },
    async listContractConcludingType() {
      const response = await http.get(`enumeration/contract-concluding-type`)

      return response
    },
    async listContractTerminationType() {
      const response = await http.get(`enumeration/contract-termination-type`)

      return response
    },
    async listSupplierChangeType() {
      const response = await http.get(`enumeration/supplier-change-type`)

      return response
    },
    async listDataSentenceSupplier() {
      const response = await http.get(`enumeration/data-sentence-supplier`)

      return response
    },
    async listGiftPromotionSource() {
      const response = await http.get(`enumeration/promotion-source`)

      return response
    },
    async listGiftPromotionFormTypes() {
      const response = await http.get(`enumeration/promotion-form-type`)

      return response
    },
    async listMessageWhom() {
      const response = await http.get(`enumeration/message-whom`)

      return response
    },
    async listMessageLevel() {
      const response = await http.get(`enumeration/message-level`)

      return response
    },
    async listUserRole() {
      const response = await http.get(`enumeration/user-role`)

      return response
    },
    async listUserStatus() {
      const response = await http.get(`enumeration/user-status`)

      return response
    },
    async listPersonalizedOfferTypes() {
      const response = await http.get(`enumeration/personalized-offer-type`)

      return response
    },
    async listPersonalizedOfferStatuses() {
      const response = await http.get(`enumeration/personalized-offer-status`)

      return response
    },
    async listPersonalizedOfferConditions() {
      const response = await http.get(`enumeration/personalized-offer-condition`)

      return response
    },
  },
}
